import { GALLERY_WORKS } from "@/data/gallery";
import { GalleryIntro, GalleryWork, GalleryInvitation } from "./gallery/GalleryParts";

export const Gallery = ({ onQuote }) => (
  <section id="realisations" className="relative py-20 sm:py-28 overflow-hidden" data-testid="gallery-section">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(650px circle at 15% 40%, rgba(236,72,153,0.12), transparent 70%)" }} />
    <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
      <GalleryIntro />
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {GALLERY_WORKS.map((work, index) => <GalleryWork key={work.id} work={work} index={index} />)}
        <GalleryInvitation onQuote={onQuote} />
      </div>
    </div>
  </section>
);